export enum CmsComponentContext {
  DEFAULT = 'default',
  FLEXGRID = 'flex-grid',
  BANNER = 'banner',
  FOOTER = 'footer'
}
